import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { noTextSelect } from '../../common/CssCommon';
import Dialog from '../Dialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../store/modules/dialog';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';

import IconMap from '../../../img/activeLink/ribbonIcon/ribbon_big_ico_map.png';
import IconMap2x from '../../../img/activeLink/ribbonIcon/ribbon_big_ico_map@2x.png';
import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';
import TextInput from '../../common/TextInput';
import { useState } from 'react';
import { insertActiveLink } from '../../plugin/activeLink';
import { URLS } from '../../../define/global';
import ga from '../../../utils/gaConnect';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  width: 568px;
  padding: 16px 16px 0px 16px;
  ${noTextSelect}
`;

const InputArea = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-flow: row;

  padding: 0px 4px;
`;

const InputStringWrapper = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const TextInputWrapper = styled.div`
  flex: 1;
  margin-left: 17px;
`;

const SubTextArea = styled.div`
  width: 470px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  padding: 5px 4px 0px;
`;

const Warning = styled.div`
  flex: 1;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #f33;
`;

const Guide = styled.a`
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #1d7ff9;
`;

const FooterWrapper = styled.div`
  padding: 18px 20px;
`;

export default function ActiveLinkMap({ isShow }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const poSDKContextState = usePOWebofficeSDKState();

  const [url, setUrl] = useState('');
  const [warning, setWarning] = useState(null);

  const onDialogClose = () => dispatch(closeDialog());

  const getSrcUrl = (url) => {
    const src = url.match(/src="(.*?)"/);
    return src && src[1] ? src[1] : null;
  };
  const onInsertMap = async (url) => {
    const src = getSrcUrl(url);
    if (src) {
      await insertActiveLink(poSDKContextState, src);
      ga.event({ category: '액티브링크', action: '콘텐츠추가', label: '지도' });
      onDialogClose();
    } else {
      ga.event({ category: '액티브링크', action: '추가실패', label: '지도' });
      const warningText = t('ActiveLink.InvalidUrl');
      setWarning(warningText);
    }
  };

  return (
    <Dialog
      icon={IconMap}
      icon2x={IconMap2x}
      title={t('ActiveLink.Map')}
      showTitleSeperateLine={true}
      showCloseBtn
      onClickCloseBtn={onDialogClose}
      isShow={isShow}>
      <DialogBody>
        <InputArea>
          <InputStringWrapper>{t('ActiveLink.Map')} URL</InputStringWrapper>
          <TextInputWrapper>
            <TextInput
              autoFocus={true}
              value={url}
              placeholder={t('ActiveLink.InputUrl')}
              onChange={(e) => setUrl(e.target.value)}
              onSubmit={onInsertMap}></TextInput>
          </TextInputWrapper>
        </InputArea>
        <SubTextArea>
          {warning && <Warning>{warning}</Warning>}
          <Guide
            href={URLS.NOTION.ACTIVELINK_INSERT_MAP_GUIDE}
            target="_blank"
            onClick={() => {
              ga.event({ category: '액티브링크', action: '가이드보기', label: '지도' });
            }}>
            {t('ActiveLink.DirectGuide')}
          </Guide>
        </SubTextArea>
      </DialogBody>
      <FooterWrapper>
        <ActiveLinkDialogFooter onSubmit={() => onInsertMap(url)}></ActiveLinkDialogFooter>
      </FooterWrapper>
    </Dialog>
  );
}
